import * as tslib_1 from "tslib";
import { selectors as streamSelectors } from '../../Stream';
var statMap = {
    love: 'loveLevel',
    comment: 'comments',
    favourite: 'favourites',
};
function getStreamIdForType(type, deviationId) {
    return "@@who:" + deviationId + ":" + type;
}
function getTotal(state, type, deviation) {
    var streamId = getStreamIdForType(type, deviation.deviationId);
    var streamTotal = streamSelectors.getTotal(state, streamId);
    // fall back to deviation stats as default
    if (streamTotal === undefined) {
        var stats = tslib_1.__assign({}, deviation.stats, (deviation.extended && deviation.extended.stats));
        return stats[statMap[type]] || 0;
    }
    return streamTotal;
}
export function getUserStreamContents(state, type, deviation) {
    var streamId = getStreamIdForType(type, deviation.deviationId);
    return {
        streamId: streamId,
        users: streamSelectors.getItems(state, streamId),
        hasMore: streamSelectors.hasMore(state, streamId),
        errorMsg: streamSelectors.getErrorMsg(state, streamId),
        isFetching: streamSelectors.isFetching(state, streamId),
        isInitialized: streamSelectors.isInitialized(state, streamId),
        total: getTotal(state, type, deviation),
    };
}
//# sourceMappingURL=selectors.js.map